"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/* istanbul ignore file */
/**
 * @name createItemData
 * @ignore
 * @description this utility function is meant to help consistently create the shape of the itemData field or return an
 * empty object to reliably map into items being passed into add or update cart functions
 * @returns {object} an object which can contain the itemData property meant for merging with cart items
 */
var createItemData = function createItemData() {
  return {
    itemData: {
      url: window.location.pathname
    }
  };
};
var _default = exports["default"] = createItemData;